// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___38qWk","addText":"AddFilterBox__addText___9tQkk","addFilterContainer":"AddFilterBox__addFilterContainer___KtyAO","addIcon":"AddFilterBox__addIcon___3WgSJ"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/matches/components/advancedSearch/AddFilterBox.scss
// module id = 1598
// module chunks = 0